module.exports = __webpack_public_path__ + "static/img/icon_pause.788f310e.png";